<tlk-card class="rx-intuitive-scan-surgical-guide-card">
	<span tlkCardHeader>{{ procedureTitle$ | async }}</span>
	<div tlkCardContent>
		<ng-container *ngIf="surgicalGuideFields$ | async as fieldsVisibility">
			<div class="rx-intuitive-scan-surgical-guide-content">
				<div class="rx-intuitive-scan-surgical-guide-type-control">
					<rx-procedure-type-control
						*ngIf="fieldsVisibility.procedureType"
						[id]="'scan-surgical-guide-type'"
					></rx-procedure-type-control>
				</div>
			</div>
		</ng-container>
	</div>
</tlk-card>
